import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const grupoSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    nome: Yup.string().required(v.requiredField('nome')),
    descricao: Yup.string().required(v.requiredField('descricao')),
  })
}
